import React from "react";
import Layout from "../layouts/Default";
import NotFound from "./404";
import fetchApi from "../fetchApi";

export default ({ match }) => {
  const { slug } = match.params;
  const [loading, setLoading] = React.useState(true);
  const [page, setPage] = React.useState();

  React.useEffect(() => {
    const getData = async () => {
      setLoading(true);
      try {
        const data = await fetchApi(`/pages?slug=${slug}`);
        const [fetchedPage] = data ? data : [];
        setPage(fetchedPage);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, [slug]);

  if (!slug || (!loading && !page)) return <NotFound />;
  return (
    <Layout title={page && page.title.rendered ? page.title.rendered : "Page"}>
      <div className="pStatic">
        {page && (
          <div className="pStatic_wrapper">
            <h2 className="pStatic_title">{page.title.rendered}</h2>
            <div
              className="pStatic_content"
              dangerouslySetInnerHTML={{ __html: page.content.rendered }}
            ></div>
          </div>
        )}
      </div>
    </Layout>
  );
};
